<template>
  <div class="tag-container q-d-flex q-justify-content-center q-flex-wrap ">
    <span
        v-for="(values, index) in getFiltersToTagList"
        :key="index"
        class="q-tag-item__button q-btn q-btn-sm q-bg-white q-m-1 q-py-1 q-rounded-3 q-shadow-sm "
        :data-field="values.field"
        :value="values.label"
        @click="filtersStore.updateFilter(values.field, values.value.label)"
    >
      <span class="q-tag-list__tooltip">{{ values.label }}</span>
      {{ values.value.label }}
    </span>
  </div>
</template>
<script setup lang="ts">
import {storeToRefs} from 'pinia'
import {useFiltersStore} from '@/store/SerpPage/FiltersStore'
import {onMounted, inject, toRefs} from 'vue'

const filtersStore = useFiltersStore()
const {getFiltersToTagList} = storeToRefs(filtersStore)

import {SmartSearchConfigInterface} from '@/core/types'

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchConfig = inject<SmartSearchConfigInterface>('SmartSearchConfig')
const {showAsideFilters} = toRefs(SmartSearchConfig.value.serp.filters)

onMounted(() => {
  if (!showAsideFilters.value) {
    filtersStore.fetchFilters()
  }
})


</script>

<style scoped>

.q-tag-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  border-top:1px solid #f2f2f2;
  padding-top: 10px;
}
.q-tag-container span.q-tag-item__button {
  position: relative;
  white-space: nowrap;
}

.q-tag-list__tooltip {
  visibility: hidden;
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  text-align: center;
  padding: 5px;
  border-radius: 4px;

  position: absolute;
  z-index: 1;
  right: 110%;
  top: 50%;
  transform: translateY(-50%);
  white-space: nowrap;

  opacity: 0;
  transition: opacity 0.3s;
}

.q-tag-container .q-tag-item__button:hover .q-tag-list__tooltip {
  visibility: visible;
  opacity: 1;
}

.q-tag-list__tooltip::before {
  content: "";
  position: absolute;
  top: 50%;
  right: -10px;
  transform: translateY(-50%) rotate(0deg);
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent transparent rgba(0, 0, 0, 0.7);
}


</style>
